import React, { useContext } from 'react';
import { EventsContext } from "../../context/events";

export default function useEventEmitter() {
	return useContext(EventsContext);
}